import { Observable } from 'rxjs';
import { BaseController } from '~client/controller/base-controller';
import { CheckoutCartResponse, PublicCheckoutCartResponse } from '~client/model/checkout-response';
import {
  CheckoutCartRequest,
  LockingCheckoutCartRequest,
} from '~client/model/purchase-checkout-request';
import {
  CheckoutPurchaseCartRequest,
  PurchaseOfferRequest,
} from '~client/model/purchase-offer-request';
import { ResponseEntity } from '~client/model/response-entity';
import { PurchaseResponse } from '~client/model/purchase-response';

/* User APIs pertaining to buying tickets at a set price outside of Auctions or Lists/Draws */
export class PurchaseController extends BaseController {
  /* Purchases inventory from a requested offer group if available. */
  public submitCartPurchase(request: CheckoutPurchaseCartRequest): Promise<PurchaseResponse> {
    return this.post('/purchase/cart', request);
  }

  /* Returns the fees and taxes for this purchase offer without locking seats */
  public publicCheckoutCart(request: CheckoutCartRequest): Promise<PublicCheckoutCartResponse> {
    return this.put('/purchase/public/cart/checkout', request);
  }

  /* Returns the fees and taxes for this purchase offer and locks seats */
  public checkoutCart(request: LockingCheckoutCartRequest): Promise<CheckoutCartResponse> {
    return this.put('/purchase/cart/checkout', request);
  }

  /* Unlocks previously locked inventory. */
  //@deprecated
  public unlockSeats$(request: PurchaseOfferRequest): Observable<ResponseEntity> {
    return this.post$('/purchase/unlock', request);
  }

  public checkoutCartClear(request: CheckoutPurchaseCartRequest): Promise<ResponseEntity> {
    return this.post('/purchase/cart/clear', request);
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src332225586/src/modules/client/src/controller/purchase-controller.ts